<template>
  <div>
    <b-card>
      <!--begin::Signup-->
      <div class="login-form login-signin">
        <div class="text-center mb-3">
          <h3 class="font-size-h1">ثبت نام</h3>
        </div>
        <b-alert variant="danger" :show="errors.length > 0">
          <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
        </b-alert>
        <!--begin::Form-->
        <b-form
          autocomplete="off"
          @submit.stop.prevent="onSubmit"
          v-if="view == 0"
        >
          <b-form-group
            id="example-input-group-0"
            label="تلفن همراه"
            label-for="example-input-0"
          >
            <b-form-input
              id="example-input-0"
              name="example-input-0"
              v-model="$v.form.mobile.$model"
              @keyup="setENChars('mobile')"
              :state="validateState('mobile')"
              aria-describedby="input-0-live-feedback"
              placeholder="تلفن همراه"
            ></b-form-input>

            <b-form-invalid-feedback id="input-0-live-feedback"
              >تلفن همراه را به صورت صحیح (09123456789) وارد
              کنید</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="example-input-group-1"
            label="پست الکترونیکی"
            label-for="example-input-1"
          >
            <b-form-input
              id="example-input-1"
              name="example-input-1"
              v-model="$v.form.email.$model"
              :state="validateState('email')"
              aria-describedby="input-1-live-feedback"
              placeholder="پست الکترونیکی"
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback"
              >پست الکترونیکی را به صورت صحیح وارد کنید</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="example-input-group-2"
            label="رمز عبور"
            label-for="example-input-2"
          >
            <b-form-input
              type="password"
              id="example-input-2"
              name="example-input-2"
              v-model="$v.form.password.$model"
              @keyup="scorePassword"
              :state="validateState('password')"
              aria-describedby="input-2-live-feedback"
              placeholder="رمز عبور"
            ></b-form-input>

            <b-form-invalid-feedback id="input-2-live-feedback"
              >رمز عبور را وارد کنید</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group>
            <div>
              <b-progress
                max="100"
                :value="passScore"
                :variant="getprogressVariant"
                show-progress
                animated
              ></b-progress>
            </div>
          </b-form-group>
          <b-form-group label="کد تایید">
            <b-row>
              <b-col cols="5">
                <b-form-input
                  v-model="form.captcha"
                  placeholder="کد تایید"
                ></b-form-input>
              </b-col>
              <b-col cols="5">
                <b-img
                  center
                  fluid
                  :src="captcha_img"
                  style="height: 38px"
                ></b-img>
              </b-col>
              <b-col>
                <b-button variant="warning" @click="resetCaptcha"
                  ><b-icon icon="arrow-clockwise"></b-icon
                ></b-button>
              </b-col>
            </b-row>
          </b-form-group>

          <!--begin::Action-->
          <div class="form-group d-flex flex-wrap flex-center">
            <button
              ref="kt_login_signin_submit"
              :class="
                'btn btn-success btn-block font-weight-bold px-9 py-4 my-3 font-size-3 ' +
                (Loading ? 'spinner spinner-light spinner-right' : '')
              "
            >
              ثبت نام
            </button>
          </div>
          <!--end::Action-->
          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'login' }"
              >ورود</router-link
            >

            <a
              href="/forget"
              class="text-hover-primary my-3 mr-2 font-weight-bold"
              id="kt_login_forgot"
              >بازیابی رمز عبور</a
            >
          </div>
          <!--end::Action-->
        </b-form>
        <b-form @submit.stop.prevent="onSubmit" v-if="view == 1">
          <div>
            <b-row>
              <b-col>
            <b-form-group label="تلفن همراه:" label-for="mobile">
              <b-form-input
                id="mobile"
                v-model="$v.form.mobile.$model"
                :disabled="true"
                placeholder="تلفن همراه"
              ></b-form-input>
            </b-form-group>
          </b-col>
            </b-row>
            <b-row>
              <b-col md="4" sm="12">
                <b-form-group label="کد ارسالی:">
                  <b-form-input
                    id="mobilecode"
                    v-model="confirmCode"
                    placeholder="کد ارسال شده"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4" sm="6" class="pt-9">
                <b-button
                  variant="warning"
                  :class="Loading ? 'spinner spinner-light spinner-right' : ''"
                  @click="PrepareValidate()"
                  :disabled="timer > 0"
                  block
                >
                  ارسال مجدد
                  <span v-if="timer > 0">({{ timer }})</span>
                </b-button>
              </b-col>
                <b-col md="4" sm="6" class="pt-9">
                <b-button
                block
                  variant="primary"
                  :class="
                    submitLoading ? 'spinner spinner-light spinner-right' : ''
                  "
                  @click="Validate()"
                  >تایید</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signup-->
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { REGISTER } from "@/core/services/store/auth.module";
import { LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";
import httpHelper from "@/helpers/httpHelper";
import ConfirmationDetails from "../User/ConfirmationDetails";
import sessionHelper from "../../helpers/sessionHelper";
const mobile = (value, vm) => /09\d{9}/g.test(value);
export default {
  mixins: [validationMixin],
  name: "register",
  components: {
    "vue-recaptcha": VueRecaptcha,
    ConfirmationDetails,
  },
  data() {
    return {
      submitLoading: false,
      errors: [],
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
        fa_name: "",
        fa_family: "",
        mobile: "",
        captcha: "",
      },
      captcha_img: "",
      Loading: false,
      passScore: 0,
      getprogressVariant: "danger",
      view: 0,
      verifyMobile: {},
      confirmCode: "",
      timer: 0,
      identifierCode:null
    };
  },
  validations: {
    form: {
      mobile: {
        // required,
        // minLength: minLength(11),
        mobile,
      },
      // fa_name: {
      //   required,
      //   minLength: minLength(3)
      // },
      // fa_family: {
      //   required,
      //   minLength: minLength(3)
      // },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
      },
    },
  },
  mounted() {
    this.identifierCode=this.$route.query!=null ? this.$route.query.Id : null;
    var self = this;
    self.resetCaptcha();
    this.captcha_int = setInterval(function () {
      self.resetCaptcha();
    }, 60000);
  },
  methods: {
    setENChars(field) {
      this.form.mobile = this.form.mobile.toEnDigits();
    },
    resetCaptcha() {
      httpHelper.getData("cp").then((res) => {
        this.captcha_img = res.result.img;
        this.form.captcha = "";
        this.form.key = res.result.key;
      });
    },
    CalcTime() {
      this.timeInterval = setInterval(() => {
        this.timer--;
        if (this.timer == 0) {
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    PrepareValidate() {
      if (this.timer > 0) {
        return;
      }
      this.Loading = true;
      httpHelper.setAuth();
      httpHelper.postData("userconf/prepare", this.verifyMobile).then((res) => {
        this.timer = 120;
        this.Loading = false;
        this.CalcTime();
      });
    },
    Validate() {
      if (this.confirmCode.length == 0) {
        this.errors.push("کد را وارد کنید");
        return;
      }
      this.submitLoading = true;
      this.verifyMobile.confirmCode = this.confirmCode;
      this.errors = [];
      httpHelper.setAuth();
      httpHelper
        .postData("userconf/validate", this.verifyMobile)
        .then((res) => {
          this.submitLoading = false;
          if (res.success) {
            if (res.result == true) {
              //this.$bvModal.hide("confirmationModal");
              //this.afterverified();
              this.$router.push({ name: "dashboard",query: { from: 'new' } });
              this.timer = 0;
            } else {
              this.errors.push("کد وارد شده صحیح نمی باشد");
            }
          } else {
            this.errors.push(res.error);
          }
        });
    },
    scorePassword() {
      var pass = this.form.password;
      var score = 0;
      if (!pass) return score;

      // award every unique letter until 5 repetitions
      var letters = new Object();
      for (var i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 7.0 / letters[pass[i]];
      }

      // bonus points for mixing it up
      var variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
      };

      var variationCount = 0;
      for (var check in variations) {
        variationCount += variations[check] == true ? 1 : 0;
      }
      score += (variationCount - 1) * 10;
      this.passScore = score;
      if (score >= 80) {
        this.getprogressVariant = "success";
      }
      if (score < 80) {
        this.getprogressVariant = "primary";
      }
      if (score < 60) {
        this.getprogressVariant = "warning";
      }
      if (score < 40) {
        this.getprogressVariant = "danger";
      }
    },
    onVerify: function (response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        username: null,
        email: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      if (this.Loading) {
        return false;
      }
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      //const fa_name = this.$v.form.fa_name.$model;
      //const fa_family = this.$v.form.fa_family.$model;
      const email = this.$v.form.email.$model;
      const password = this.$v.form.password.$model;
      const mobile = this.$v.form.mobile.$model.toEnDigits();
      
      this.errors = [];
      var data = {
        email: email,
        password: password,
        //fa_name: fa_name,
        //fa_family: fa_family,
        mobile: mobile,
        captcha: this.form.captcha.toEnDigits(),
        key: this.form.key,
        identifier_code: this.identifierCode,
      };
      this.Loading = true;
      httpHelper.postData("users/register", data).then((res) => {
        this.Loading = false;
        if (!res.success) {
          this.resetCaptcha();
          for (const key in res.error) {
            if (res.error.hasOwnProperty(key)) {
              const element = res.error[key];
              element.forEach((er) => {
                this.errors.push(er);
              });
            }
          }
        } else {
          sessionHelper.setUser(res.result);
          this.verifyMobile = res.result.verifyMobile;
          this.view = 1;
        }
      });
    },
  },
};
</script>
